import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FinalCTA.css';

function FinalCTA() {
  const navigate = useNavigate();

  const handleCTAClick = () => {
    navigate('/login');
  };

  return (
    <section id="final-cta" className="final-cta-section container">
      <div className="final-cta-surface">
        <span className="final-cta-accent" aria-hidden="true" />
        <h2 className="final-cta-title">Ready to Simplify Your Business Management?</h2>
        <p className="final-cta-text">
          Join hundreds of entrepreneurs who've streamlined their operations with BOSS. Start your free trial today.
        </p>
        <div className="final-cta-actions">
          <button className="primary-btn" onClick={handleCTAClick}>Start Free Trial</button>
          {/* <button className="secondary-btn">Schedule a Demo</button> */}
        </div>
        {/* <p className="final-cta-note">
          <em>30-day money-back guarantee | No setup fees | Cancel anytime</em>
        </p> */}
      </div>
    </section>
  );
}

export default FinalCTA;